import React from "react"
import ToolTip from "react-portal-tooltip"
import { IDevicePermissions } from "../../models"
import { grey500 } from "material-ui/styles/colors"
import DevicePermissionsInfo from "./DevicePermissionsInfo"
interface IProps {
	deviceId: string
	devicePermissions: IDevicePermissions
}
interface IState {
	open: boolean
}

export default class DevicePermissionsDetailCol extends React.Component<IProps, IState>  {
	constructor(props) {
		super(props)
		this.state = {
			open: false
		}
	}

	render() {
		return (
			<div style={{ textAlign: "center" }}>
				{this.props.devicePermissions && [
					<ToolTip
						key="tooltip"
						active={this.state.open}
						position="left"
						arrow="center"
						parent={"#" + "device-permissions-" + this.props.deviceId}
						tooltipTimeout={50}
					>
						<div style={{ padding: 10 }}>
							<DevicePermissionsInfo
								devicePermissions={this.props.devicePermissions}
							/>
						</div>
					</ToolTip>,
					<i
						key="icon"
						id={"device-permissions-" + this.props.deviceId}
						className="fa fa-info-circle"
						style={{ color: grey500, cursor: "pointer", fontSize: 16 }}
						onClick={e => {
							e.stopPropagation()
							this.setState({ open: !this.state.open })
						}}
						onMouseOut={() => this.setState({ open: false })}
					/>
				]}
			</div>
		)
	}
}